import { render } from "./uni_card_list.vue?vue&type=template&id=2c55f0be"
import script from "./uni_card_list.vue?vue&type=script&lang=js"
export * from "./uni_card_list.vue?vue&type=script&lang=js"

import "./uni_card_list.vue?vue&type=style&index=0&id=2c55f0be&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__